/* ========================================================================
//	CASE
======================================================================== */

(function ($) {
	
    var

    $transitory1 = $('#body_hash').find('.transitory-1'),
    $transitory2 = $('#body_hash').find('.transitory-2'),


    caseResize = function (_args) {


        if (_args.winStepNum > 2) {
            $transitory2.children().detach().appendTo($transitory1);
        }
        else {
            $transitory1.children().detach().appendTo($transitory2);
        }

    }

    MyTools.onWinResize({ func: caseResize });
	
	
	MyTools.initPg('CASE');
	
})(jQuery, MyTools);